import { formatQuery } from 'react-querybuilder';
import ValidatedValueEditor from './subComponents/ValidatedValueEditor';

export const numericOperators = [
  { name: '=', label: '=' },
  { name: '!=', label: '≠' },
  { name: '>', label: '>' },
  { name: '<', label: '<' },
  { name: '>=', label: '≥' },
  { name: '<=', label: '≤' },
  { name: 'null', label: 'is null' },
  { name: 'notNull', label: 'is not null' },
];

export const stringOperators = [
  { name: 'contains', label: 'contains' },
  { name: 'beginsWith', label: 'begins with' },
  { name: 'endsWith', label: 'ends with' },
  { name: 'doesNotContain', label: 'not contain' },
  { name: 'doesNotBeginWith', label: 'not begin with' },
  { name: 'doesNotEndWith', label: 'not end with' },
  { name: 'null', label: 'is null' },
  { name: 'notNull', label: 'is not null' }
];

export const booleanOperators = [
  { name: '=', label: '=' }
];

export const booleanValues = [
  { name: 'true', label: 'True' },
  { name: 'false', label: 'False' }
];

export const defaultQuery = { id: 'g-root', combinator: 'and', rules: [] };

// Static Configuration - Defined outside component to avoid recreating on every render
export const CONTROL_CLASSNAMES = {
  queryBuilder: 'queryBuilder-branches',
  addRule: 'btn btn-primary btn-sm',
  addGroup: 'btn btn-primary btn-sm',
  removeRule: 'btn btn-secondary btn-sm',
  removeGroup: 'btn btn-secondary btn-sm'
};

// Static — defined outside component to avoid re-creating on every render
export const CONTROL_ELEMENTS = { valueEditor: ValidatedValueEditor };

export const QUERY_BUILDER_TRANSLATIONS = {
  addRule: { label: '+ Condition', title: 'Add condition' }
};

export const formatQueryToJson = (query, fields) => {
  if (!query?.rules?.length) {
    return '';
  }
  
  // Options: 'json_without_ids', 'json', 'sql'
  return formatQuery(query, {
    format: 'json_without_ids',
    fields: fields
  });
};
